import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useState,
} from "react";
import { TakuTypeSettei } from "../types/TakuTypeSettei";

export const TakuContext = createContext(
  {} as {
    takuSettei: TakuTypeSettei[];
    setTakuSettei: Dispatch<SetStateAction<TakuTypeSettei[]>>;
  }
);

export const TakuProvider = (props: any) => {
  const { children } = props;
  //const [showModal, setShowModal] = useState(false);
  const [takuSettei, setTakuSettei] = useState<TakuTypeSettei[]>([
    {
      id: 1,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",

      intervalTime: 3,
      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,

      //setShowModal: void
    },
    {
      id: 2,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,
      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 3,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
      //updateFlag: false,
    },
    {
      id: 4,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 5,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 6,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 7,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 8,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 9,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 10,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 11,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 12,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 13,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 14,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
    {
      id: 15,
      takuId: "",
      status: false,
      shokai: true,
      color: "gray",
      hime: "1",
      startTime: "",
      intervalTime: 3,

      timer: 7,
      courseTime: 60,
      seatingList: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      updateFlag: false,
      showFlag: false,
    },
  ]);

  return (
    <TakuContext.Provider value={{ takuSettei, setTakuSettei }}>
      {children}
    </TakuContext.Provider>
  );
};
